module.exports = __webpack_public_path__ + "img/3.525f1924.jpg";